import { render, staticRenderFns } from "./ReversalForm.vue?vue&type=template&id=0fb5ca08&scoped=true&"
import script from "./ReversalForm.vue?vue&type=script&lang=js&"
export * from "./ReversalForm.vue?vue&type=script&lang=js&"
import style0 from "./ReversalForm.vue?vue&type=style&index=0&id=0fb5ca08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5ca08",
  null
  
)

export default component.exports